<template>
  <transition name="modal">
    <div
      class="custom-modal"
      id="modal"
      @click="handleOutsideClick"
      v-if="showModal"
    >
      <transition name="modal-content">
        <div
          id="modal-content"
          style="width: 350px"
          class="custom-modal-content"
        >
          <div class="flex gap-2 items-center my-2">
            <div class="table__search-input-wrapper w-4/5">
              <span class="pr-2 opacity-50"><search-icon /> </span>
              <input
                type="text"
                class="table__search-input"
                placeholder="Search..."
                v-model="querySearch"
              />
            </div>
            <span class="cursor-pointer" @click="closeModal">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.51266 0.613906L0.613281 1.51328L6.10266 7.00078L0.613281 12.4889L1.51328 13.3883L7.00078 7.89891L12.4889 13.3877L13.3877 12.4889L7.89891 7.00078L13.3877 1.51266L12.4883 0.613281L7.00078 6.10266L1.51266 0.613906Z"
                  fill="#4C4C4C"
                />
              </svg>
            </span>
          </div>
          <el-collapse v-if="this.$store.state.authentication.env == 'development'" class="" v-model="selectedModule">
            <el-collapse-item
              v-for="item in devItems"
              :key="item.name"
              :name="item.name"
            >
              <template slot="title">
                <div class="flex flex-col">
                  <h3 class="text-base font-semibold">{{ item.name }}</h3>
                  <p class="leading-3 font-normal">{{ item.description }}</p>
                </div>
                <div style="color: white">________</div>
              </template>
              <div class="flex flex-col gap-2 mt-4">
                <div 
                  v-for="child in item.children"
                  :key="child.name"
                >
                  <router-link
                    v-if="child.showFor.find(x => x == userAccountType ) ? true : false"
                    :to="child.to"
                    style="color: black"
                >
                    <div class="flex gap-2 cursor-pointer" @click="closeModal">
                      <span>
                        <img :src="getImgUrl(child.icon)" />
                      </span>
                      <p class="font-semibold">{{ child.name }}</p>
                    </div>
                  </router-link>
                </div>
                
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-if="this.$store.state.authentication.env == 'staging' || this.$store.state.authentication.env == 'production'" class="" v-model="selectedModule">
            <el-collapse-item
              v-for="item in stagingItems"
              :key="item.name"
              :name="item.name"
            >
              <template slot="title">
                <div class="flex flex-col">
                  <h3 class="text-base font-semibold">{{ item.name }}</h3>
                  <p class="leading-3 font-normal">{{ item.description }}</p>
                </div>
                <div style="color: white">________</div>
              </template>
              <div class="flex flex-col gap-2 mt-4">
                <div 
                  v-for="child in item.children"
                  :key="child.name"
                >
                  <router-link
                    v-if="child.showFor.find(x => x == userAccountType ) ? true : false"
                    :to="child.to"
                    style="color: black"
                  >
                    <div class="flex gap-2 cursor-pointer" @click="closeModal">
                      <span>
                        <img :src="getImgUrl(child.icon)" />
                      </span>
                      <p class="font-semibold">{{ child.name }}</p>
                    </div>
                  </router-link>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedModule: 1,
      querySearch: "",
      hideRoles: {
        name: "Roles and Privileges",
        icon: "roles.svg",
        to: "/settings/roles-and-privileges",
      },
      devItems: [
        {
          name: "Basic Account Info",
          description: "user profile and account details",
          children: [
            {
              name: "Account Profile",
              icon: "account.svg",
              to: "/settings/account-profile",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            },
            {
              name: "Terminals",
              icon: "location.svg",
              to: "/settings/terminals",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            },
            { name: "Fleet", icon: "fleet.svg", to: "/settings/vehicles", showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] },
            { name: "Routes", icon: "routes.svg", to: "/settings/routes", showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] },
          ],
        },

        {
          name: "Payment And Accounting",
          description: "Manage payments and billing accounts",
          children: [
            {
              name: "Pricing & Collection",
              icon: "payment.svg",
              to: "/settings/pricing-and-collections",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]

            },
            {
              name: "Accounting",
              icon: "accounting.svg",
              to: "/settings/account-settings",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            }
          ],
        },
        {
          name: "Users and Security",
          description:
            "Manage Users and groups in your organisation, set up security policies.",
          children: [
            {
              name: "Security Policy",
              icon: "security.svg",
              to: "/settings/security-policy",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] 
            },
            {
              name: "Users",
              icon: "usersandgroups.svg",
              to: "/settings/users-and-groups",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
            {
              name: "Approval",
              icon: "approval.svg",
              to: "/settings/approval",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
            {
              name: "Domain",
              icon: "domains.svg",
              to: "/settings/users-and-groups",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
          ],
        },
        {
          name: "Applications",
          description: "your Subscription and apps.",
          children: [
            {
              name: "Dynamic Numbering System",
              icon: "dynamicnumbering.svg",
              to: "/settings/dynamicnumbering",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
            {
              name: "CRM",
              icon: "crm.svg",
              to: "/crm/settings",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
            {
              name: "Messaging",
              icon: "messaging.svg",
              to: "/settings/messaging",
              showFor: ["enterprise_custome", "enterprise_partner"] 
            },

          ],
        },
      ],
      stagingItems: [
        {
          name: "Basic Account Info",
          description: "user profile and account details",
          children: [
            {
              name: "Account Profile",
              icon: "account.svg",
              to: "/settings/account-profile",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            },
            {
              name: "Terminals",
              icon: "location.svg",
              to: "/settings/terminals",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            },
            { name: "Fleet", icon: "fleet.svg", to: "/settings/vehicles", showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] },
            { name: "Routes", icon: "routes.svg", to: "/settings/routes", showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] },
          ],
        },

        {
          name: "Payment And Accounting",
          description: "Manage payments and billing accounts",
          children: [
            {
              name: "Pricing & Collection",
              icon: "payment.svg",
              to: "/settings/pricing-and-collections",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"]
            }
          ],
        },
        {
          name: "Users and Security",
          description:
            "Manage Users and groups in your organisation, set up security policies.",
          children: [
            {
              name: "Security Policy",
              icon: "security.svg",
              to: "/settings/security-policy",
              showFor: ["enterprise_customer", "enterprise_partner", "solo_operator"] 
            },
            {
              name: "Roles & Privileges",
              icon: "roles.svg",
              to: "/settings/roles-and-privileges",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            },
            {
              name: "Users",
              icon: "usersandgroups.svg",
              to: "/settings/users-and-groups",
              showFor: ["enterprise_customer", "enterprise_partner"] 
            }
          ],
        },
      ],
    };
  },
  watch: {
    querySearch(value) {
      this.items = this.items.filter((item) =>
        item.children.filter(
          (child) => child.name.toUpperCase().indexOf(value.toUpperCase()) > -1
        )
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    handleOutsideClick() {
      let modal = document.getElementById("modal");
      if (event.target == modal) {
        this.$emit("close-modal");
      }
    },
    getImgUrl(pic) {
      return require("./icons/" + pic);
    },
  },
  computed : {
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
  }
};
</script>
<style  scopped>
.el-collapse-item {
  margin: 1rem 0;
}
.el-collapse-item__header {
  line-height: 30px !important;
}
.custom-modal {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  transition: all ease 0.5s;
  /* padding: 30% 0; */
}

/* Modal Content/Box */
.custom-modal-content {
  background-color: #ffffff;
  padding: 1.5rem;
  border: 1px solid #888;
  width: 40%;
  margin-top: 4.5rem;
  /* max-height: 90%; */
  border-radius: 6px;
  overflow-y: auto;
}
.custom-modal-content::-webkit-scrollbar {
  width: 1rem;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.modal-enter-to,
.modal-leave {
  opacity: 1;
  transform: translateY(0);
}
.modal-enter-active,
.modal-leave-active {
  transition: all ease 0.5s;
}

@media screen and (max-width: 768px) {
  .custom-modal-content {
    width: 100% !important;
    padding: 0.5rem;
  }
}
</style>
